import React, { Component } from 'react'
import './css/index.css'
import GettingStarted from './GettingStarted'
import Layout from "../../components/Layout"


class AccountManagement extends Component {
    render() {
        return (
            <Layout {...this.props}>
                <div className="accountManagement">
                    <div>
                        <h1 className="main-color headText">ACCOUNT MANAGEMENT</h1>
                        <hr/>
                        <GettingStarted />
                    </div>
                </div>
            </Layout>
        )
    }
}

export default AccountManagement;